<nav class="flex items-center gap-[15px] bg-white py-2 text-sm font-medium text-white md:gap-[30px] lg:gap-[10px]">
<!-- class="block sm:hidden"  -->
  <button (click)="toogleShowSearchBarOnDemand()" [ngClass]="[currentScreenSize() === 'SM' ? 'block' : 'hidden']">
    <ln-search-svg-icon class="h-6 w-6"></ln-search-svg-icon>
  </button>
  <ln-main-menu-buton [label]="'buttons.lang' | transloco" (clicked)="languageSwitcher()">
    @if (activeLanguage() === Languages.es.valueOf()) {
      <ln-spanish-svg-icon icon></ln-spanish-svg-icon>
    } @else {
      <ln-english-fag-svg-icon icon></ln-english-fag-svg-icon>
    }
  </ln-main-menu-buton>
  <ln-main-menu-buton
    [label]="'buttons.aboutUs' | transloco"
    [ngClass]="[currentScreenSize() === 'LG' ? 'block': 'hidden']"
    (clicked)="navigateToAboutUsPage()">
    <ln-nosotros-svg-icon icon></ln-nosotros-svg-icon>
  </ln-main-menu-buton>
<!-- class="hidden lg:block" -->
  <!-- <ln-main-menu-buton [label]="'buttons.blog' | transloco" [ngClass]="[currentScreenSize() === 'LG' ? 'block': 'hidden']"
  (clicked)="navigateToLunaNuevaBlog()"
  >
    <ln-book-svg-icon icon></ln-book-svg-icon>
  </ln-main-menu-buton> -->
  <ln-main-menu-buton [label]="'buttons.services' | transloco" [ngClass]="[currentScreenSize() === 'LG' ? 'block': 'hidden']"
  (clicked)="navigateToServicesPage()"
  >
    <ln-frame-svg-icon icon></ln-frame-svg-icon>
  </ln-main-menu-buton>
  <!--  <ln-main-menu-account-button [label]="'Mi cuenta'" class="hidden sm:block">-->
  <!--    <ln-person-svg-icon icon></ln-person-svg-icon>-->
  <!--  </ln-main-menu-account-button> -->
<!--  class="block lg:hidden" -->
  <ln-movil-menu-button [ngClass]="[currentScreenSize() === 'LG' ? 'hidden': 'block']">
    <ln-movil-menu-svg-icon [class]="'h-[24px] w-[24px]'" icon></ln-movil-menu-svg-icon>
  </ln-movil-menu-button>
  <ln-main-menu-shopping-cart-buton [label]="'buttons.cart' | transloco">
    <ln-shopping-cart-svg-icon icon></ln-shopping-cart-svg-icon>
  </ln-main-menu-shopping-cart-buton>
</nav>
